import { createSelector } from '@reduxjs/toolkit';

const getPage = state => state.page;

const DEFAULT_MEGA_MENU = {};
export const getMegaMenu = createSelector(
  getPage,
  ({ megaMenu = DEFAULT_MEGA_MENU } = {}) => megaMenu,
);

export const getMegaMenuActiveLevel = createSelector(getMegaMenu, ({ activeLevel }) => activeLevel);

export const megaMenuIsOpen = createSelector(getMegaMenu, ({ isOpen = false }) => isOpen);

export const getMegaMenuMaxLength = createSelector(
  getMegaMenu,
  ({ maxLength = null }) => maxLength,
);

export const getMegaMenuRoot = createSelector(getMegaMenu, ({ menuRoot = null }) => menuRoot);

const DEFAULT_MEGA_MENU_MENUS = [];
export const getMegaMenuMenus = createSelector(
  getMegaMenu,
  ({ menus = DEFAULT_MEGA_MENU_MENUS }) => menus,
);

export const getExperienceFragmentKeyForActiveMenuItem = createSelector(
  getMegaMenu,
  ({ menus }) => (menus.length > 0 && menus[menus.length - 1]?.banner) || undefined,
);
